import React, { useState } from 'react';
import SalesTopSection from '../../../../components/Sales-Information/SalesTopSection';
import SalesSubHeading from '../../../../components/Sales-Information/SalesSubHeading';
import SalesTabMobile from '../../../../components/Sales-Information/SalesTabMobile';

const StarHallMobile = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const galleryImages = [
    {
      src: "/images/SalesInfo/sales star/별빛관_slide01.jpg",
      alt: "별빛관 사진 1"
    },
    {
      src: "/images/SalesInfo/sales star/별빛관_slide02.jpg",
      alt: "별빛관 사진 2"
    },
    {
      src: "/images/SalesInfo/sales star/별빛관_slide03.jpg",
      alt: "별빛관 사진 3"
    },
    {
      src: "/images/SalesInfo/sales star/별빛관_slide04.jpg",
      alt: "별빛관 사진 4"
    },
    {
      src: "/images/SalesInfo/sales star/별빛관_slide05.jpg",
      alt: "별빛관 사진 5"
    }
  ];

  const handlePaginationClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handleImageClick = () => {
    // Cycle to the next image when clicking on the image
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
  };

  return (
    <div className="announcement-list-page sale-info-page">
      <SalesTopSection />

      {/* Main Content */}
      <main className="main-content">
        <SalesSubHeading heading="분양가격" heading2="별빛관" />

        {/* Pricing Section */}
        <section className="sky-hall-special-room-mobile-pricing-section">
          <SalesTabMobile selectedHall="별빛관" />

          {/* Gallery Images */}
          <div className="sky-hall-special-room-mobile-pricing-image-container">
            <img
              src={galleryImages[currentImageIndex].src}
              alt={galleryImages[currentImageIndex].alt}
              className="sky-hall-special-room-mobile-gallery-current-img"
              onClick={handleImageClick}
              style={{ cursor: 'pointer' }}
            />
          </div>

          {/* Pagination Circles */}
          <div className="sky-hall-special-room-mobile-pagination-container">
            {galleryImages.map((image, index) => (
              <button
                key={index}
                className={`sky-hall-special-room-mobile-pagination-dot ${index === currentImageIndex ? 'sky-hall-special-room-mobile-pagination-dot-active' : ''
                  }`}
                onClick={() => handlePaginationClick(index)}
                aria-label={`Go to image ${index + 1}`}
              />
            ))}
          </div>

          {/* Price Table */}
          <div className="sky-hall-special-room-mobile-price-table-container">
            <div className="sky-hall-special-room-sales-price-header">
              <p className="sky-hall-special-room-price-unit">단위 : 만원</p>
            </div>
            <div className="sky-hall-special-room-mobile-price-table">
              <div className="sky-hall-special-room-mobile-table-header">
                <div className="sky-hall-special-room-mobile-table-cell sky-hall-special-room-mobile-header-cell">안치단</div>
                <div className="sky-hall-special-room-mobile-table-cell sky-hall-special-room-mobile-header-cell">개인</div>
                <div className="sky-hall-special-room-mobile-table-cell sky-hall-special-room-mobile-header-cell">특별</div>
              </div>


              <div className="sky-hall-special-room-mobile-table-row">
                <div className="sky-hall-special-room-mobile-table-cell">7</div>
                <div className="sky-hall-special-room-mobile-table-cell">800</div>
                <div className="sky-hall-special-room-mobile-table-cell">1,600</div>
              </div>



              <div className="sky-hall-special-room-mobile-table-row">
                <div className="sky-hall-special-room-mobile-table-cell">6</div>
                <div className="sky-hall-special-room-mobile-table-cell">850</div>
                <div className="sky-hall-special-room-mobile-table-cell">1,700</div>
              </div>


              <div className="sky-hall-special-room-mobile-table-row">
                <div className="sky-hall-special-room-mobile-table-cell">5</div>
                <div className="sky-hall-special-room-mobile-table-cell">1,000</div>
                <div className="sky-hall-special-room-mobile-table-cell">2,000</div>
              </div>

              <div className="sky-hall-special-room-mobile-table-row">
                <div className="sky-hall-special-room-mobile-table-cell">4</div>
                <div className="sky-hall-special-room-mobile-table-cell">1,000</div>
                <div className="sky-hall-special-room-mobile-table-cell">2,000</div>
              </div>

              <div className="sky-hall-special-room-mobile-table-row">
                <div className="sky-hall-special-room-mobile-table-cell">3</div>
                <div className="sky-hall-special-room-mobile-table-cell">900</div>
                <div className="sky-hall-special-room-mobile-table-cell">1,800</div>
              </div>


              <div className="sky-hall-special-room-mobile-table-row">
                <div className="sky-hall-special-room-mobile-table-cell">2</div>
                <div className="sky-hall-special-room-mobile-table-cell">800</div>
                <div className="sky-hall-special-room-mobile-table-cell">1,600</div>
              </div>


              <div className="sky-hall-special-room-mobile-table-row">
                <div className="sky-hall-special-room-mobile-table-cell">1</div>
                <div className="sky-hall-special-room-mobile-table-cell">700</div>
                <div className="sky-hall-special-room-mobile-table-cell">1,400</div>
              </div>


              <div className="sky-hall-special-room-mobile-table-footer">
                <div className="sky-hall-special-room-mobile-table-cell sky-hall-special-room-mobile-header-cell">관리비 (1位)</div>
                <div className="sky-hall-special-room-mobile-table-cell sky-hall-special-room-mobile-management-fee-value">7만원/1년</div>
              </div>
            </div>
          </div>

          {/* Management Fee Information - Copied from PC */}
          <div className="sky-hall-special-room-mobile-management-fee-info">
            <div className="sky-hall-special-room-mobile-info-icon">
              <img src="/images/SalesInfo/sales-below-img.png" alt="Info icon" />
            </div>
            <div className="sky-hall-special-room-mobile-info-text">
              <ul>
                <li>관리비는 물가상승률에 따라 변동될 수 있습니다.</li>
                <li>관리비는 안치시 5년 선납입니다.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>

    </div>
  );
};

export default StarHallMobile; 